export const AppRoutes = {
  Login: "/login",
  Dashboard: "/dashboard",
  Creatives: "/creatives/list",
  VastBuilder: "/builder/vast",
  AdaptiveRendering: "/builder/adaptive",
  CreativeValidator: "/builder/validator",
  CreativeInfo: "/creatives/info/*",
  Wizard: {
    MappingList: "wizard/mapping",
    Mapping: "wizard/status/:id",
    SdkList: "wizard/sdk",
    Sdk: "wizard/sdk/:id",
    AdapterList: "wizard/adapter",
    Adapter: "wizard/adapter/:id",
    Spm: "wizard/spm",
    Crawler: "wizard/crawler",
    SystemHealth: "wizard/system-health",
    SKAdNetwork: "wizard/skadn",
    AdAttributionKit: "wizard/aak",
    PluginList: "wizard/plugin",
    Plugin: "wizard/plugin/:id",
    Recommendations: "wizard/recommendations",
  },
};
